import {checkError, closeAlert, receiveErrorAlert} from "../commonsActions";
import {downloadPromoterVideoStatsCsv, getPromoterVideoStats} from "../../helpers/promoterStatsService";

export const FETCH_PROMOTER_VIDEO_STATS_BEGIN = 'FETCH_PROMOTER_VIDEO_STATS_BEGIN';
export const FETCH_PROMOTER_VIDEO_STATS_SUCCESS = 'FETCH_PROMOTER_VIDEO_STATS_SUCCESS';
export const FETCH_PROMOTER_VIDEO_STATS_ERROR = 'FETCH_PROMOTER_VIDEO_STATS_ERROR';

/*
 * action creators
 */

const fetchPromoterVideoStatsSuccess = res => ({
    type: FETCH_PROMOTER_VIDEO_STATS_SUCCESS,
    payload: {
        promoterVideoStats: res.data,
        numberOfElements: res.numberOfElements,
        totalElements: res.totalElements,
        totalPages: res.totalPages
    }
});

const fetchPromoterVideoStatsError = error => ({
    type: FETCH_PROMOTER_VIDEO_STATS_ERROR,
    payload: {
        error: error,
    }
});

export const fetchPromoterVideoStats = query => dispatch => {
    dispatch({type: FETCH_PROMOTER_VIDEO_STATS_BEGIN});
    return getPromoterVideoStats(query).then(res => {
        dispatch(fetchPromoterVideoStatsSuccess(res));
        return res;
    }, error => {
        dispatch(fetchPromoterVideoStatsError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const fetchPromoterVideoStatsCsv = query => dispatch => {
    return downloadPromoterVideoStatsCsv(query).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/promoter/promoterVideoStatsActions.js